import { format, parseISO } from 'date-fns';

export function getDaysInMonth(month: number, year: number) {
  const date = new Date(year, month, 1);
  const days = [];
  while (date.getMonth() === month) {
    days.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }
  return days;
}

export function diffDateInHours(dateToCompare: string) {
  const now = new Date();
  const dateCompare = new Date(dateToCompare);
  return (now.getTime() - dateCompare.getTime()) / (1000 * 60 * 60);
}

export class DatetimeBR {
  static getFullFriendlyDate(date: string, showSeconds = false): string {
    if (!date) {
      return '';
    }
    if (!showSeconds) {
      return format(parseISO(date), 'dd/MM/yyyy HH:mm');
    } else {
      return format(parseISO(date), 'dd/MM/yyyy HH:mm:ss');
    }
  }
}

export const formatDate = (value: string): string => {
  if (!value) {
    return '';
  }

  return format(parseISO(value), 'dd/MM/yyyy');
};

export const formatDateToInput = (date: any) => {
  if (!date) return '';
  // Se já for string e tiver o 'T' (ISO), pegamos apenas a parte da data
  // Se for objeto Date, convertemos para ISO string e pegamos a parte da data
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  return d.toISOString().split('T')[0]; 
};

export const formatarData = (date: any) => date ? date.toISOString().split('T')[0] : '';

export const parseDDMMYYYY = (dateStr) => {
  if (typeof dateStr !== 'string') return null;

  const parts = dateStr.split('/');
  if (parts.length !== 3) return null;

  const [dayStr, monthStr, yearStr] = parts;
  const day = parseInt(dayStr, 10);
  const month = parseInt(monthStr, 10) - 1;
  const year = parseInt(yearStr, 10);

  if (isNaN(day) || isNaN(month) || isNaN(year)) return null;

  const date = new Date(year, month, day);
  if (
      date.getFullYear() !== year ||
      date.getMonth() !== month ||
      date.getDate() !== day
  ) {
      return null;
  }

  return date;
}

// Soma dias a uma data no formato do input type="date" (AAAA-MM-DD).
// Monta a data em horario local (e nao via Date(string), que assume UTC) para
// que o resultado nao "ande" um dia por causa do fuso.
export const addDaysToInputDate = (value: string, days: number): string => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return '';

  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + days);

  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
